<template>
    <div class="job-board">
        <div v-if="joblist.length > 0">
            <transition-group name="fade" mode="out-in" @after-leave="afterLeave">
                <JobBoardListItemPublic
                    v-for="j in joblist"
                    :current="isCurrent( j.id )"
                    :key="j.id"
                    :uid ="j.id"
                    :logo="j.logoData"
                    :title="j.title"
                    :company="j.company"
                    :city="j.city"
                    :state="j.state"
                    :type="j.type"
                    :tags="j.tags"
                    :created="j.created"
                    :remote="j.remote">
                </JobBoardListItemPublic>
            </transition-group>
        </div>
        <JobBoardListEmpty v-else></JobBoardListEmpty>
    </div>
</template>

<script>
import JobBoardListItemPublic from '@/components/JobBoardListItemPublic.vue'
import JobBoardListEmpty from '@/components/JobBoardListEmpty.vue'

export default {
    name: 'JobBoardList',
    props : [ 'current' ],
    components : {
        JobBoardListItemPublic,
        JobBoardListEmpty
    },
    methods : {
        isCurrent( id ){
            return +id === +this.current
        },
        afterLeave () {
          this.$root.$emit('triggerScroll')
        }
    },
    computed : {
        joblist () {
            const q = this.$route.query
            return this.$store.getters.filteredJobList( {
                tags   : q.tags ? q.tags.split( "," ) : undefined,
                type   : q.type || undefined,
                loc    : q.state || undefined,
                desc   : q.search || undefined,
                remote : !!q.remote || undefined
            } )
        }
    },
    mounted () {
        this.$store.dispatch('getAllJobs')
    }
}
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    .job-board{
        
        @media screen and (min-width: $b1){
            flex-grow: 1;
            padding: 0 1.25rem;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition-duration: 0.3s;
      transition-property: opacity;
      transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
      opacity: 0
    }
</style>